import React from 'react';
import { connect } from 'react-redux';
import { ISelect, IStatus } from "@treelab/common-logic";

import { getSelectOptionsWithData, isAbsentCellValue } from '../../../../helpers';
import { IRootState } from '../../../../modules/stores';
import SelectList from '../../../FieldTypes/Select';
import StatusList from '../../../FieldTypes/Status';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string; // Same deal. If this is passed here, it means the table element is using.
}

const MultiWithFieldId: React.FC<IProps & IConnectProps> = ({ cell, field }) => {
  if (isAbsentCellValue(cell) || !Array.isArray(cell) || !field) return null;

  const optsWithData = getSelectOptionsWithData(cell, field.typeOptions.options);

  return <SelectList items={optsWithData} />;
};

const SingleWithFieldId: React.FC<IProps & IConnectProps> = ({ cell, field }) => {
  if (isAbsentCellValue(cell) || !field) return null;

  const availableOptions = field.typeOptions.options || [];
  const item = availableOptions.find((o: ISelect) => o.optionId === cell);

  return <SelectList items={[item]} />;
};

const StatusWithFieldId: React.FC<IProps & IConnectProps> = ({ cell, field }) => {
  if (isAbsentCellValue(cell) || !field) return null;

  const availableOptions = field.typeOptions.statuses || [];
  const item = availableOptions.find((o: IStatus) => o.statusId === cell);

  return <StatusList items={[item]} />;
};


const mapState = ({ core }: IRootState, { fieldId, recordId }: IProps) => ({
  cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
  field: core.fieldById[fieldId],
});

export default {
  MultiWithFieldId: connect(mapState)(MultiWithFieldId),
  SingleWithFieldId: connect(mapState)(SingleWithFieldId),
  Raw: SelectList, // Exposed for Lookup
  StatusWithFieldId: connect(mapState)(StatusWithFieldId),
  StatusRaw: StatusList,
};
